/* eslint-disable no-unused-vars */
import {React,useState, useEffect} from 'react'
import { makeApiRequest } from "../../mydatafeed/helpers";
import  { API_URL } from "../../api-config";
import './table.css'
import { Button } from "@mui/material";
import Slider from '@mui/material/Slider';
import { Line } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Tables from '../../components/Tables.jsx';
import axios from "axios"
Chart.register(...registerables);

const AirbnbSlider = styled(Slider)(({ theme }) => ({
  color: '#3a8589',
  height: 3,
  padding: '13px 0',
  '& .MuiSlider-thumb': {
    height: 27,
    width: 27,
    backgroundColor: '#fff',
    border: '1px solid currentColor',
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
    },
    '& .airbnb-bar': {
      height: 9,
      width: 1,
      backgroundColor: 'currentColor',
      marginLeft: 1,
      marginRight: 1,
    },
  },
  '& .MuiSlider-track': {
    height: 3,
  },
  '& .MuiSlider-rail': {
    color: theme.palette.mode === 'dark' ? '#bfbfbf' : '#d8d8d8',
    opacity: theme.palette.mode === 'dark' ? undefined : 1,
    height: 3,
  },
}));

const TrackRecord = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [chartData, setChartData] = useState(null);
  const [totalDateRange, setTotalDateRange] = useState([]);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [, setMarks] = useState([]);
  const itemsPerPage = 9 ;
  const [differentialData, setDifferentialData] = useState({
    cumulativeRentability: 0,
    cumulativeProfit: 0,
    cumulativePesos: 0,
    linealRentability:0,
  });

  const [cumulativeLinealRentability, setCumulativeLinealRentability] = useState([]);
  const [activeView, setActiveView] = useState('rentabilidad');
  const [categoriaEntrada, setCategoriaEntrada] = useState('Todos');
  const [filteredData, setFilteredData] = useState([]);
  //const [currentItems, setCurrentItems] = useState([]);
  const [filteredData2, setFilteredData2] = useState([]);
  // Nuevo estado para mantener los datos filtrados
  // Estado para las métricas calculadas
  const [metrics, setMetrics] = useState({
    totalProfitPesos: 0,
    totalProfitReal: 0,
    rentabilidadLineal: 0,
    totalTransactions: 0,
  });

  const loadData = async () => {
    const token = localStorage.getItem("token");
    try {
      // const data = await makeApiRequest(`${API_URL}/sistema/track_record`);
      let data ;
      await axios.get(`${API_URL}/trading-api/sistema/track_record`,
        { headers: { "Content-Type": "application/json",
          "Authorization": "Bearer "+ token
         }}
      ).then((response) => {
        data = response.data;})
      console.log('data',data)
      setData(data);
    } catch (error) {
      console.error('Error al cargar los datos', error);
    }
  };

  useEffect(() => {
    if (data && data.length > 0) {
      const processedDates = data
        .filter(item => item.Fecha_Cierre !== null && item.Fecha_Cierre !== undefined)
        .map(item => new Date(item.Fecha_Cierre));
      const validDates = processedDates.filter(date => date !== null);

      const minDate = new Date(Math.min.apply(null, validDates));
      const maxDate = new Date(Math.max.apply(null, validDates));

      setTotalDateRange([minDate.getTime(), maxDate.getTime()]);
      setSelectedEndDate(maxDate.getTime());

      const linealRentabilityData = data.reduce((accumulator, item, index) => {
        const currentLinealRentability = (Number(item.Profit_real) / Number(item.Precio_entrada)) * 100;
        if (index === 0) {
          accumulator.push(currentLinealRentability);
        } else {
          accumulator.push(accumulator[index - 1] + currentLinealRentability);
        }
        return accumulator;
      }, []);
      setCumulativeLinealRentability(linealRentabilityData);

      setChartData({
        labels: validDates.map(date => {
          if (date instanceof Date && !isNaN(date)) {
            return date.toLocaleDateString("es-AR");
          } else {
            console.error("Invalid date object:", date);
            return "";
          }
        }),
        datasets: [
          {
            label: 'Rentabilidad Money Management',
            data: data.map(item => Number(item.Rentabilidad_acum)),
            borderColor: 'rgba(75,192,192,1)',
            backgroundColor: 'rgba(75,192,192,0.2)',
            fill: true,
            yAxisID: 'y',
          },
          {
            label: 'Rentabilidad Lineal',
            data: linealRentabilityData,
            borderColor: 'rgba(97, 178, 131, 0.64)',
            backgroundColor: 'rgba(5, 195, 84, 0.25)',
            fill: true,
            yAxisID: 'y',
          }
        ]
      });
      const rentabilityDif = parseFloat((data[data.length - 1].Rentabilidad_acum).toFixed(3));
      const profitDif = parseFloat((data[data.length - 1].Profit_acum).toFixed(3));
      const pesosDif = parseFloat((data[data.length - 1].Pesos_acum ).toFixed(3));
      const linealRentability =  parseFloat(linealRentabilityData[linealRentabilityData.length - 1]).toFixed(3);

      setDifferentialData({
        cumulativeRentability: rentabilityDif,
        cumulativeProfit: profitDif,
        cumulativePesos: pesosDif,
        cumulativeLinealRentability: linealRentability,
      });

      setMarks([
        { value: minDate.getTime(), label: minDate.toLocaleDateString("es-AR") },
        { value: maxDate.getTime(), label: maxDate.toLocaleDateString("es-AR") }
      ]);
    }
  }, [data]);
  
  const options = {
    plugins: {
        datalabels: {
    display: false // ← Esta línea es la clave
  },
      legend: {
        labels: {
          color: 'white',
          font: {
            size: 16
          }
        }
      }
    },
    scales: {
      x: {
        title: {
          display: true,
            text: 'Fecha',
            color: '#CFCFCF',
        },
        ticks: {
        color: '#CFCFCF'
        }
      },
      y: {
        title: {
          display: true,
          text: 'Rentabilidad % ',
          color: '#CFCFCF',
        },
        ticks: {
          color: '#CFCFCF'
        }
      },
    }
  };

  const lastItemIndex = currentPage * itemsPerPage;
  const firstItemIndex = lastItemIndex - itemsPerPage;
  const currentItems = filteredData2.slice(firstItemIndex, lastItemIndex);

  const totalPages = Math.ceil(data.length / itemsPerPage);
  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    const newFilteredData = data.filter(item => {
      if (categoriaEntrada === 'Todos') return true;
      return item.Categoria_Entrada === categoriaEntrada;
    });
    setFilteredData2(newFilteredData);
  }, [categoriaEntrada, data]);

  useEffect(() => {
    // Aquí se debería recalcular todo en base a filteredData
    // Esta es una simplificación, debes ajustar según tu lógica específica
    recalculateChart(filteredData);
  }, [filteredData]);

  const recalculateChart = (filteredData) => {
    if (filteredData && filteredData.length > 0) {
        const datesnew = filteredData
        .filter(item => item.Fecha_Cierre !== null && item.Fecha_Cierre !== undefined)
        .map(item => new Date(item.Fecha_Cierre));
        const validDates = datesnew.filter(date => date !== null);
        const filteredLinealRentability = filteredData.reduce((accumulator, item, index) => {
          const currentLinealRentability = (Number(item.Profit_real) / Number(item.Precio_entrada)) * 100;
          if (index === 0) {
            accumulator.push(currentLinealRentability);
          } else {
            accumulator.push(accumulator[index - 1] + currentLinealRentability);
          }
          return accumulator;
        }, []);

        setChartData({
          labels: validDates.map(date => {
            if (date instanceof Date && !isNaN(date)) {
              return date.toLocaleDateString("es-AR");
            } else {
              console.error("Invalid date object:", date);
              return "";
            }
          }),
          datasets: [
            {
              label: 'Rentabilidad Money Management',
              data: filteredData.map(item => Number(item.Rentabilidad_acum)), // Usar filteredData aquí
              borderColor: 'rgba(75,192,192,1)',
              backgroundColor: 'rgba(75,192,192,0.2)',
              fill: true,
              yAxisID: 'y',
            },
            {
              label: 'Rentabilidad Lineal',
              data: filteredLinealRentability, // Y aquí también
              borderColor: 'rgba(97, 178, 131, 0.64)',
              backgroundColor: 'rgba(5, 195, 84, 0.25)',
              fill: true,
              yAxisID: 'y',
            }
          ]
        });
        
        let initialElement;
        if (filteredData[0] === data[0]) {
          initialElement = { Rentabilidad_acum: 0, Profit_acum: 0, Pesos_acum: 0, RentabilidadLineal: 0 };
        } else {
          const initialIndex = data.findIndex(item => item === filteredData[0]) - 1;
          initialElement = data[initialIndex] || { Rentabilidad_acum: 0, Profit_acum: 0, Pesos_acum: 0, RentabilidadLineal: 0 };
        }

        const rentabilityDif = parseFloat((filteredData[filteredData.length - 1].Rentabilidad_acum - initialElement.Rentabilidad_acum).toFixed(3));
        const profitDif = parseFloat((filteredData[filteredData.length - 1].Profit_acum - initialElement.Profit_acum).toFixed(3));
        const pesosDif = parseFloat((filteredData[filteredData.length - 1].Pesos_acum - initialElement.Pesos_acum).toFixed(3));
        const linealRentabilityDif =  parseFloat(filteredLinealRentability[filteredLinealRentability.length - 1] - (initialElement.RentabilidadLineal || 0)).toFixed(3);
        setDifferentialData({
          cumulativeRentability: rentabilityDif,
          cumulativeProfit: profitDif,
          cumulativePesos: pesosDif,
          cumulativeLinealRentability: linealRentabilityDif,
        });
  }
  }

  const handleChange = (event, newValue) => {
    setSelectedEndDate(newValue);
    setMarks([
      { value: newValue[0], label: new Date(newValue[0]).toLocaleDateString("es-AR") },
      { value: newValue[1], label: new Date(newValue[1]).toLocaleDateString("es-AR") }
    ]);

    const filteredData = data.filter(item => {
      const itemDate = new Date(item.Fecha_Cierre).getTime();
      return itemDate <= newValue;
    });
    const filteredLinealRentability = cumulativeLinealRentability.filter((_, index) => {
      const itemDate = new Date(data[index].Fecha_Cierre).getTime();
      return itemDate <= newValue;
    });
    recalculateChart(filteredData, filteredLinealRentability);
  };

  useEffect(() => {
    // Filtrar datos según la categoría de entrada seleccionada
    const filteredData2 = data.filter(item => {
      if (categoriaEntrada === 'Todos') return true;
      return item.Categoria_Entrada === categoriaEntrada;
    });
  
    // Calcular métricas específicas para los datos filtrados
    const totalProfitPesos = filteredData2.reduce((acc, item) => acc + item.Profit_pesos, 0);
    const totalProfitReal = filteredData2.reduce((acc, item) => acc + item.Profit_real, 0);
    const totalTransactions = filteredData2.length; // 
    
  
    // Actualizar estado con las métricas calculadas
    setMetrics({
      totalProfitPesos,
      totalProfitReal,
      totalTransactions,
    });
  
    // // Actualizar estado con los datos filtrados para la tabla y recalculación de la paginación
    // setCurrentItems(filteredData.slice(0, itemsPerPage));
    // setTotalPages(Math.ceil(filteredData.length / itemsPerPage));
    const lastItemIndex = currentPage * itemsPerPage;
    const firstItemIndex = lastItemIndex - itemsPerPage;
    // eslint-disable-next-line no-unused-vars
    const currentItems = filteredData2.slice(firstItemIndex, lastItemIndex);
    const totalPages = Math.ceil(filteredData2.length / itemsPerPage);
  
  }, [categoriaEntrada, data]);
  
  
  return (
    <div className="table-container">
      <h2>Estadísticas USDCLP Project By QRT Solutions</h2>
      <br />
      <div>
      <Button
        className={`buttonTrack ${activeView === 'rentabilidad' ? 'active' : ''}`}
        onClick={() => setActiveView('rentabilidad')}
      >
        Rentabilidad
      </Button>
      <Button
        className={`buttonTrack ${activeView === 'analisis' ? 'active' : ''}`}
        onClick={() => setActiveView('analisis')}
      >
        Análisis Estadístico
      </Button>
      </div>
      {activeView === 'rentabilidad' && (
      <><div>
          <h2>Filtra las estadísticas por Fecha</h2>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Box sx={{ width: 300 }}>
              <AirbnbSlider
                value={selectedEndDate}
                onChange={handleChange}
                valueLabelDisplay="auto"
                aria-labelledby="range-slider"
                getAriaValueText={(value) => `${new Date(value).toLocaleDateString()}`}
                valueLabelFormat={(value) => `${new Date(value).toLocaleDateString()}`}
                marks={[{ value: totalDateRange[0], label: new Date(totalDateRange[0]).toLocaleDateString("es-AR") }, { value: selectedEndDate, label: new Date(selectedEndDate).toLocaleDateString("es-AR") }]}
                min={totalDateRange[0]}
                max={totalDateRange[1]} />


            </Box>
          </Box>
        </div><div className="statistics-container">
            <>
              <h2>Rentabilidad Money Management: {differentialData.cumulativeRentability} % </h2>
              <h2>Rentabilidad Lineal: {differentialData.cumulativeLinealRentability} % </h2>
              <h2>Profit Acumulado: $ {differentialData.cumulativeProfit ? parseFloat(differentialData.cumulativeProfit).toLocaleString('es-ES') : '0'}</h2>
            </>
          </div><div className='chart-div' >
            {chartData ? (
              <Line data={chartData} options={options} />
            ) : (
              <p>Loading chart...</p>
            )}
          </div>
          <br></br>
          <div className="filter-buttons-container">
          <button className={`buttonTrack ${categoriaEntrada === 'Todos' ? 'active' : ''}`} onClick={() => setCategoriaEntrada('Todos')}>Todos</button>
          <button className={`buttonTrack ${categoriaEntrada === 'Sistema' ? 'active' : ''}`} onClick={() => setCategoriaEntrada('Sistema')}>Sistema</button>
          <button className={`buttonTrack ${categoriaEntrada === 'Config' ? 'active' : ''}`} onClick={() => setCategoriaEntrada('Config')}>Config</button>
        </div>

        <div className="metrics-container">
          <h2>Total Profit Pesos: ${metrics.totalProfitReal.toLocaleString('es-ES')}</h2>
          <h2>Total Transactions: {metrics.totalTransactions}</h2>
        </div>
          <br></br>
          <br></br>
          <h2> Tabla con todos los Trades completados del proyecto</h2>
          <div className="flex flex-col justify-center px-2 py-2 overflow-y-scroll h-auto">
            {/* Asegúrate de que Tables es un componente que puede recibir y usar "items" correctamente */}
            <Tables type="track_record" items={currentItems} />
              </div>

              <div className="pagination flex flex-row justify-center mb-3">
                <button className='btn-periodo' onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
                  Primera
                </button>
                <button className='btn-periodo' onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
                  Anterior
                </button>
                <span>
                  {currentPage} de {totalPages}
                </span>
                <button className='btn-periodo' onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>
                  Siguiente
                </button>
                <button className='btn-periodo' onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}>
                  Última
                </button>
              </div>
          </>
        )}
        {activeView === 'analisis' && (
          <div>
            <br></br>
            <h2>Coming Soon ... </h2>
            </div>
        )}
    </div>
  );
}

export default TrackRecord;